module.exports = __webpack_public_path__ + "static/media/Aalidhra17a2.48426916.jpg";